import { parse } from 'valibot';
import useRequest from '@/shared/composables/use-request';
import type { EntityResponse } from '@/shared/types/api';
import type { IArticle, TArticles, TFetchArticlesPayload } from './../types';
import { articleSchema } from './schemes';

class Article {
	async fetchArticles(payload: TFetchArticlesPayload): EntityResponse<TArticles> {
		try {
			const response = await useRequest().$get(`/articles/by_letter/${payload.letter_id}/`, {
				query: payload,
			});

			if (response.status === 'error') {
				return response;
			}

			return response.data as TArticles;
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async fetchArticleById(id: IArticle['id']): EntityResponse<IArticle> {
		try {
			const response = await useRequest().$get(`/articles/${id}/`, {
				query: { id },
			});

			if (response.status === 'error') {
				return response;
			}

			return parse(articleSchema, response.data);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async sendArtcticleMetricDownload(article_id: IArticle['id']) {
		try {
			await useRequest().$get('/articles/metric_download/', {
				query: { article_id },
			});
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async fetchArticleFile(url: string, fileName: string): Promise<void> {
		try {
			const response = await fetch(url);

			if (!response.ok) {
				throw new Error(`Network response was not ok (${response.status})`);
			}

			const blob = await response.blob();
			const objectURL = URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = objectURL;
			link.download = fileName;

			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			URL.revokeObjectURL(objectURL);
		} catch (error) {
			console.error('Ошибка при загрузке файла:', error);
		}
	}
}

export default new Article();
